export default "__VITE_ASSET__BObo$iIJ__"